(ns pfo.message.model
  (:require
    [pfo.api :as api :refer [process-error]]
    [pfo.util :as util]
    [promesa.core :as p]))

(defn received-messages [page]
  (api/ajaxp "/messages/received/" {:params (util/remove-nil-values {:page page})}))

(defn sent-messages [page]
  (api/ajaxp "/messages/sent/" {:params (util/remove-nil-values {:page page})}))
